import { Injectable } from '@angular/core'
import { SubscribingObject } from '../player/common/SubscribingObject'

@Injectable()
export class StorageService extends SubscribingObject<any> {
  private currentVersion = '2'
  private currentVersionKey = 'btms.tv.ls.v'

  constructor() {
    super()
    // get current version as string
    const version = this.getLocalStorage().getItem(this.currentVersionKey)
    // clear ls if our version is older
    if (version !== this.currentVersion) {
      this.clearStorage()
    }
    // save current version
    this.getLocalStorage().setItem(this.currentVersionKey, this.currentVersion)

    window.addEventListener('storage', e => {
      this.triggerEvent(e.key, null)
    })
  }

  /*getLanguageFromStorage() {
        if (JSON.parse(localStorage.language).value === 'en') {
            return true
        } else {
            return false
        }
    }*/

  save(key: string, data: any) {
    const localData = new LocalStorageDataItem(data)
    const value = JSON.stringify(localData)
    this.getLocalStorage().setItem(key, value)
  }

  load<T>(key: string, defaultValue: T = null): T {
    const localDataAsString = this.getLocalStorage().getItem(key)
    if (!localDataAsString) {
      return defaultValue
    }

    const localData = JSON.parse(localDataAsString)
    return localData.value
  }

  deleteItem(key: string) {
    this.getLocalStorage().removeItem(key)
  }

  clearStorage() {
    this.getLocalStorage().clear()
  }

  private getLocalStorage(): { clear: Function; removeItem: Function; setItem: Function; getItem: Function } {
    if (!!localStorage) {
      return localStorage
    }

    // return null-object
    const message = "localStorage doesn't support"
    return {
      clear() {
        console.warn(message)
      },
      removeItem() {
        console.warn(message)
      },
      setItem() {
        console.warn(message)
      },
      getItem() {
        console.warn(message)
      }
    }
  }
}

export class LocalStorageDataItem<T> {
  value: T
  isJSON: boolean

  constructor(value: T) {
    this.value = value
    this.isJSON = typeof value === 'object' ? true : false
  }
}
